import { render, staticRenderFns } from "./departmentInfo.vue?vue&type=template&id=7a72dc1c&scoped=true"
import script from "./departmentInfo.vue?vue&type=script&lang=js"
export * from "./departmentInfo.vue?vue&type=script&lang=js"
import style0 from "./departmentInfo.vue?vue&type=style&index=0&id=7a72dc1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72dc1c",
  null
  
)

export default component.exports